// import { HStack, Field, Heading, Input, Text } from "@chakra-ui/react"
import { Editable, Heading } from "@chakra-ui/react"

export const EditableField = ({ editing, fieldname, data, dataelement, handler, placeholder = "", isHeading = false }) => {
    return (
        <>
            {(isHeading && !editing) ? (<Heading>{(!dataelement && data) ? data : (data?.[dataelement] ?? "")}</Heading>) :
                (<Editable.Root
                    activationMode={editing ? "click" : "none"}
                    value={(!dataelement && data) ? data : (data?.[dataelement] ?? "")}
                    onValueChange={(e) => { dataelement ? handler(dataelement, e.value) : handler(e.value) }}
                    disabled={!editing}
                    placeholder={placeholder}
                >
                    <Editable.Label whiteSpace="nowrap" fontSize="md" fontWeight="medium">{fieldname}</Editable.Label>
                    <Editable.Preview
                        cursor={editing ? "text" : "default"}
                        outline={editing ? "1px solid gray" : "none"}
                        outlineOffset={editing ? "1px" : "none"}
                        pointerEvents={!editing ? "none" : "auto"}
                    />
                    <Editable.Input />
                </Editable.Root>)}
        </>)
}